import _ from 'lodash';
import React from 'react';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';

import {Icon} from '../../../ui-toolkit';
import {AnchorLink} from '../../../ui-toolkit/elements/button/btn-type/AnchorLink';

function FileDownloadFormatter({entity, t}) {
    if (_.isObject(entity) && _.get(entity, 'fileUrl')) {
        return (
            <DownloadBtn
                color="primary"
                ghost
                href={entity.fileUrl}
                target="_blank"
                download
                onClick={(e) => e.stopPropagation()}
                rel="noreferrer">
                <Icon name="download" />
                {t('generalShared.download')}
            </DownloadBtn>
        );
    }

    return '-';
}

export default withTranslation()(FileDownloadFormatter);

const DownloadBtn = styled(AnchorLink)`
    padding: 2px 8px !important;
`;
